export default __webpack_public_path__ + "img/aiface.c86181aa.png";